import styled from 'styled-components'

export const Tooltip = styled.span`
  display: flex;
  position: absolute;
  left: 0.5rem;
  padding: 10px;
  z-index: 10;
  background-color: #35353f;
  color: white;
  font-size: 14px;
  line-height: 18px;
  white-space: normal;
  border-radius: 10px;
  opacity: 0;
  transition: all 0.5s ease-in-out;
  max-width: 97%;
`
